module.exports = __webpack_public_path__ + "c18b245086aa1718c23a4a88a46fa032.svg";